/* RESPONSIBLE TEAM: team-ml */
/* eslint-disable @intercom/intercom/no-bare-strings */

/**
 * Custom comparison options for Fin SDR predicates.
 * Restricts available comparisons to match the Python service expectations:
 * - EQUAL = "equal" → eq
 * - NOT_EQUAL = "not equal" → ne
 * - HIGHER = "higher" → gt
 * - LOWER = "lower" → lt
 * - PRESENT_IN = "present in" → in
 *
 * Note: Date/datetime/event attributes are filtered out at the attribute level.
 */

const STRING_COMPARISONS = {
  comparison: [{
    label: 'equal',
    value: 'eq'
  }, {
    label: 'not equal',
    value: 'ne'
  }, {
    label: 'contains',
    value: 'contains'
  }]
};
const NUMERIC_COMPARISONS = {
  comparison: [{
    label: 'equal',
    value: 'eq'
  }, {
    label: 'not equal',
    value: 'ne'
  }, {
    label: 'higher',
    value: 'gt'
  }, {
    label: 'lower',
    value: 'lt'
  }]
};
const SELECT_COMPARISONS = {
  comparison: [{
    label: 'present in',
    value: 'in'
  }]
};
const BOOLEAN_COMPARISONS = {
  comparison: [{
    label: 'is true',
    value: 'true'
  }, {
    label: 'is false',
    value: 'false'
  }]
};
const LLM_EVALUATION_COMPARISONS = {
  comparison: [{
    label: 'matches',
    value: 'matches'
  }]
};
export default {
  string: STRING_COMPARISONS,
  numeric: NUMERIC_COMPARISONS,
  select: SELECT_COMPARISONS,
  boolean: BOOLEAN_COMPARISONS,
  llmEvaluation: LLM_EVALUATION_COMPARISONS,
  // These handle list-type attributes (tags, plans, etc.)
  numericSelect: NUMERIC_COMPARISONS,
  optionalSelect: SELECT_COMPARISONS,
  attributeOptionSelect: SELECT_COMPARISONS,
  attributeOptionSelectExtended: SELECT_COMPARISONS
};